/**
 * Inventory — tracks consumable item counts.
 */

import type { ItemDef } from "./ItemDef";

export class Inventory {
  private counts = new Map<string, number>();

  /** Add items by id. */
  add(id: string, amount: number = 1): void {
    this.counts.set(id, (this.counts.get(id) ?? 0) + amount);
  }

  /** Get count for an item. */
  count(id: string): number {
    return this.counts.get(id) ?? 0;
  }

  /** Use one item. Returns false if none left. */
  use(id: string): boolean {
    const c = this.count(id);
    if (c <= 0) return false;
    this.counts.set(id, c - 1);
    return true;
  }

  /** Check if player has at least one of this item. */
  has(id: string): boolean {
    return this.count(id) > 0;
  }
}
